import { Theme } from '@mui/material';
import Card, { CardProps } from '@mui/material/Card';
import { keyframes } from '@mui/styled-engine';
import { styled } from '@mui/styles';

interface Props {
  theme: Theme;
}

const background = keyframes`
  0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

export const PmiCard = styled((props: CardProps) => <Card {...props} />)(({ theme }: Props) => ({
  borderLeft: `3px solid ${theme.palette.cdmBrand.main}`,
  borderRight: `3px solid ${theme.palette.cdmBrand.main}`,
  transition: 'all 250ms !important',
  animation: `${background} 3000ms ${theme.transitions.easing.easeInOut}`,
  background: 'white',
  cursor: 'pointer',
  '&:hover': {
    borderWidth: '6px',
    background:
      'linear-gradient(-45deg, #eeecec 0%, #fafafa 15%, #eeecec 15%, #fff 35%, #eeebeb 85%,#e7e5e5 100%)',
  },
  '& .MuiCardContent-root, & .MuiCardContent-root:last-child': {
    paddingTop: '12px',
    paddingBottom: '18px',
  },
}));
